module.exports = __webpack_public_path__ + "static/media/Whale_laptop.5a8dd1a4.gif";